import megatron from 'megatron';
import {apiConfig} from '@ibibo/hotels-config';

export const shareHotelPropertiesPOST = async (data) => {
  const url = `/mysharehotels/`;
  return await megatron({
    name: 'Share Hotels Preview Api',
    type: 'POST',
    url,
    requestData: JSON.stringify(data) ,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'text/html'
    },
  });
}


export const shareHotelPropertiesPOSTPDF = async (data) => {
    const url = `/mypdfsharehotels/`;
    return await megatron({
      name: 'Share Hotels PDF Preview Api',
      type: 'POST',
      url,
      requestData: JSON.stringify(data) ,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/html'
      },
    });
  }

export const whatsappLogin = async (callback) => {
  const url = `${apiConfig.__MYPARTNER__}/api/v12/whatsapp/login`;
  let last_index = 0;
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.withCredentials = true;
    xhr.setRequestHeader('Content-Type', 'multipart/form-data')
    xhr.onerror = function () {
      reject({success:false});
    };
    xhr.onprogress = function () {
      const curr_index = xhr.responseText.length;
      if (last_index == curr_index) return;
      const s = xhr.responseText.substring(last_index, curr_index);
      last_index = curr_index;
      const respJSON = JSON.parse(s);
      callback({...respJSON});
      if (respJSON.data && respJSON.data.responseComplete) {
        resolve(respJSON);
      } else {
        reject({success:false});
      }
    }
    xhr.send();
  })
}

export const sendWhatsAppMessage = async (data) => {
  const url = `${apiConfig.__MYPARTNER__}/api/v12/whatsapp/send`;

  return await megatron({
    name: 'Send WhatsApp Message',
    type: 'POST',
    url,
    requestData: JSON.stringify(data),
    credentials: 'include'
  });
}
